export default class PageHeaderController {
    /* @ngInject */
    constructor($window, $rootScope, AuthService) {
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.AuthService = AuthService;
        this.username = undefined;
        this.showTransportLink = false;
        this.showReportsLink = true;
    }

    $onInit() {
        const account = this.$window.localStorage.getItem('account');
        if (account) {
            this.username = JSON.parse(account).user.userName;
        }

        if (this.AuthService.isTransportChief()) {
            this.showTransportLink = true;
            this.showReportsLink = false;
        }
    }

    logout() {
        this.AuthService.logout();
    }

    toggle() {
        this.menuOpen = !this.menuOpen;
        this.$rootScope.$emit('sb.page.menu', { open: this.menuOpen });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/page-header/page-header.controller.js